import script from "./RightCalendarHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RightCalendarHeader.vue?vue&type=script&setup=true&lang=js"

import "./RightCalendarHeader.vue?vue&type=style&index=0&id=cdbbef6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdbbef6a"]])

export default __exports__